// extracted by mini-css-extract-plugin
export var backButton = "parts-module--backButton--xseJP";
export var button = "parts-module--button--UidiM";
export var colored = "parts-module--colored--MUA0J";
export var copyright = "parts-module--copyright--BpUfC";
export var greyedOut = "parts-module--greyedOut--lWKVS";
export var logo = "parts-module--logo--hUYH7";
export var stepCount = "parts-module--stepCount--C9IN2";
export var title = "parts-module--title--EICiT";